import { render, staticRenderFns } from "./FormTemplateQuestionContent.vue?vue&type=template&id=6f130b3a&"
import script from "./FormTemplateQuestionContent.vue?vue&type=script&lang=js&"
export * from "./FormTemplateQuestionContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports